'use client';
import { useState, useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';
import { useRouter } from 'next/navigation';
import { api } from '../lib/api';

export default function LoginPage() {
  const { user, loading, login } = useAuth();
  const router = useRouter();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [logoUrl, setLogoUrl] = useState<string | null>(null);

  useEffect(() => {
    api<{ url: string | null }>('/api/settings/logo')
      .then((d) => setLogoUrl(d.url))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!loading && user) router.push('/dashboard');
  }, [loading, user]);

  if (loading || user) return <div className="flex items-center justify-center min-h-screen">Chargement...</div>;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    try { await login(email, password); router.push('/dashboard'); }
    catch (err: any) { setError(err.message); }
  };

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="w-full max-w-sm bg-white rounded-lg shadow p-8">
        <div className="flex flex-col items-center mb-6">
          {logoUrl && <img src={logoUrl} alt="Logo" className="h-12 w-auto mb-4" />}
          <h1 className="text-2xl font-bold">Neper Devis</h1>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1">Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-red-500" required />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Mot de passe</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-red-500" required />
          </div>
          {error && <p className="text-red-600 text-sm">{error}</p>}
          <button type="submit" className="w-full text-white py-2 rounded transition"
            style={{ backgroundColor: '#FF3500' }}>Se connecter</button>
        </form>
      </div>
    </div>
  );
}
